'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _startCase2 = require('lodash/startCase');

var _startCase3 = _interopRequireDefault(_startCase2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatDuration = _utils.FormattingUtils.formatDuration,
    formatDurationInMonthsOrDays = _utils.FormattingUtils.formatDurationInMonthsOrDays,
    getOrDefault = _utils.FormattingUtils.getOrDefault;

var TermsTableRow = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(TermsTableRow, _Component);

  function TermsTableRow() {
    _classCallCheck(this, TermsTableRow);

    return _possibleConstructorReturn(this, (TermsTableRow.__proto__ || Object.getPrototypeOf(TermsTableRow)).apply(this, arguments));
  }

  _createClass(TermsTableRow, [{
    key: 'onChange',
    value: function onChange(event) {
      this.props.onChange(this.props.id, event.target.value);
    }
  }, {
    key: 'durationText',
    value: function durationText() {
      var _props = this.props,
          id = _props.id,
          length = _props.length,
          duration = _props.term.duration;


      if (id === length - 1 && duration === null) {
        return 'Uncapped';
      }

      var durationFormatted = formatDurationInMonthsOrDays(duration);
      var prefix = void 0;
      if (id === 0) {
        prefix = 'First';
      } else if (id === length - 1) {
        prefix = 'Last';
      } else {
        prefix = 'Next';
      }

      return prefix + ' ' + durationFormatted;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          locked = _props2.locked,
          _props2$term = _props2.term,
          schedule_bucket_duration = _props2$term.schedule_bucket_duration,
          interest_accrual_duration = _props2$term.interest_accrual_duration,
          interest_rate = _props2$term.interest_rate,
          interest_type = _props2$term.interest_type,
          interestRateText = formatDuration(interest_accrual_duration),
          interestTypeText = (0, _startCase3.default)(interest_type).toLowerCase(),
          scheduleBucketText = getOrDefault(formatDurationInMonthsOrDays(schedule_bucket_duration));


      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.durationText()
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-interest-rate' },
          locked ? interest_rate : _react2.default.createElement('input', {
            name: 'rate',
            onChange: this.onChange,
            step: 0.1,
            type: 'number',
            value: interest_rate
          }),
          '% every ',
          interestRateText,
          ', ',
          interestTypeText
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right' },
          scheduleBucketText
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TermsTableRow;
}(_react.Component), _class2.propTypes = {
  id: _propTypes2.default.number.isRequired,
  length: _propTypes2.default.number.isRequired,
  locked: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  term: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class;

var _default = TermsTableRow;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatDuration, 'formatDuration', '/app/src/components/page-case/TermsTableRow.js');
  reactHotLoader.register(formatDurationInMonthsOrDays, 'formatDurationInMonthsOrDays', '/app/src/components/page-case/TermsTableRow.js');
  reactHotLoader.register(getOrDefault, 'getOrDefault', '/app/src/components/page-case/TermsTableRow.js');
  reactHotLoader.register(TermsTableRow, 'TermsTableRow', '/app/src/components/page-case/TermsTableRow.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/TermsTableRow.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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